import { ofetch } from "ofetch";

const apiUrl = process.env.VUE_APP_API_URL;

function request(method) {
    return async (url, body) => {
        try {
            return await ofetch(`${apiUrl}${url}`, { method, body, parseResponse: JSON.parse });
        } catch (err) {
            throw new Error(err?.data);
        }
    };
}

const fetchWrapper = {
    get: request("GET"),
    post: request("POST"),
    put: request("PUT"),
    delete: request("DELETE"),
    patch: request("PATCH"),
};

export default fetchWrapper